import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { AttachFile, Delete, Visibility, VisibilityOff } from "@material-ui/icons";
import { DropzoneArea } from "material-ui-dropzone";

const STORAGE_URI = process.env.REACT_APP_STORAGE_URI;

function getFileName(url) {
  if (!url) return "file";
  const parts = url.split("/");
  const raw = decodeURIComponent(parts[parts.length - 1]);
  // Remove server-side metadata prefix like [0][1234567890123][12345]
  return raw.replace(/^(\[\d+\]\[\d+\]\[\d+\])/, "");
}

export default function MultiFileManager({ fileUrls = [], setFileUrls, newFiles = [], setNewFiles, disabled = false }) {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [dropzoneKey, setDropzoneKey] = useState(0);

  // Reset DropzoneArea khi newFiles được reset về rỗng từ bên ngoài
  useEffect(() => {
    if (newFiles.length === 0) {
      setDropzoneKey((prev) => prev + 1);
    }
  }, [newFiles.length]);

  const togglePreview = (url) => {
    setPreviewUrl((prev) => (prev === url ? null : url));
  };

  const handleRemoveExisting = (index) => {
    const updated = fileUrls.filter((_, i) => i !== index);
    if (previewUrl === fileUrls[index]) setPreviewUrl(null);
    setFileUrls(updated);
  };

  // console.log("MultiFileManager render", { fileUrls, newFiles, previewUrl });

  const fullPreviewUrl = previewUrl ? `/api/v1${previewUrl}` : null;
  // console.log("Preview URL:", fullPreviewUrl, fileUrls, newFiles);

  return (
    <Box>
      {/* Existing uploaded files */}
      {fileUrls.length > 0 && (
        <List dense disablePadding>
          {fileUrls.map((url, index) => (
            <ListItem
              key={`existing-${index}`}
              dense
              button
              selected={previewUrl === url}
              onClick={() => togglePreview(url)}
              style={{ borderRadius: 4, paddingRight: disabled ? 52 : 96 }}
            >
              <AttachFile fontSize="small" style={{ marginRight: 6, color: "rgba(0,0,0,0.4)", flexShrink: 0 }} />
              <ListItemText
                primary={getFileName(url)}
                primaryTypographyProps={{ variant: "body2", noWrap: true, title: getFileName(url) }}
              />
              <ListItemSecondaryAction>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePreview(url);
                  }}
                >
                  {previewUrl === url ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                </IconButton>
                {!disabled && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveExisting(index);
                    }}
                  >
                    <Delete fontSize="small" style={{ color: "#f44336" }} />
                  </IconButton>
                )}
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      )}

      {fileUrls.length === 0 && disabled && (
        <Typography variant="body2" style={{ color: "rgba(0,0,0,0.38)", fontStyle: "italic" }}>
          Không có file minh chứng
        </Typography>
      )}

      {/* Inline preview iframe */}
      {previewUrl && fullPreviewUrl && (
        <Box style={{ margin: "8px 0", border: "1px solid #e0e0e0", borderRadius: 4, overflow: "hidden" }}>
          <iframe
            key={previewUrl}
            src={fullPreviewUrl}
            title="preview"
            style={{ width: "100%", height: 420, border: "none", display: "block" }}
          />
          <Box
            style={{
              padding: "4px 8px",
              background: "#f5f5f5",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button size="small" href={fullPreviewUrl} target="_blank" rel="noreferrer" color="primary" variant="text">
              Mở bản gốc
            </Button>
            <Button size="small" onClick={() => setPreviewUrl(null)} variant="text" style={{ marginLeft: 4 }}>
              Đóng xem trước
            </Button>
          </Box>
        </Box>
      )}

      {/* Dropzone for adding new files */}
      {!disabled && (
        <>
          {fileUrls.length > 0 && <Divider style={{ margin: "8px 0" }} />}
          <DropzoneArea
            key={dropzoneKey}
            onChange={(files) => setNewFiles(files)}
            showPreviews={true}
            showPreviewsInDropzone={false}
            useChipsForPreview
            previewText="File mới đã chọn:"
            dropzoneText="Kéo thả hoặc nhấp để thêm file mới"
            filesLimit={10}
            maxFileSize={25000000} // 25MB
            acceptedFiles={["application/pdf", "image/*"]}
          />
        </>
      )}
    </Box>
  );
}

